// extracted by mini-css-extract-plugin
export var actions = "_va-4";
export var item = "_va-1";
export var price = "_va-3";
export var quantity = "_va-2";
export var table = "_va-0";